/**
 * Elements stripped from model-generated markdown.
 *
 * Retrieved documents are editable by many people, so an answer can carry
 * attacker-chosen markdown. An image is the dangerous case: the browser
 * fetches its address with no click, which would let a poisoned document
 * exfiltrate answer text through the URL.
 */
export const MARKDOWN_BLOCKED = ['img'];
